import React, { useState, useEffect } from "react";
import Nav from "./Nav";
import Mapper from "./Mapper";
import Preview from "./Preview";
import Header from "./Header";
import Spinner from "./Spinner";
import { Box, Typography, Backdrop } from "@mui/material";
import ApiRequest from "../ApiRequest";
import Grid from "@mui/material/Unstable_Grid2";
import useStore from "../Store";

function Container(props) {
  const { extensionId, journeyId, interactionId, setIsSpinner } = useStore((state) => state.header);
  const [token, setToken] = useState("");
  const [code, setCode] = useState(props.code);
  const [channels, setChannels] = useState(null);
  const [channel, setChannel] = useState({});
  const [tokens, setTokens] = useState(null);
  const [templates, setTemplates] = useState(null);
  const [template, setTemplate] = useState(null);
  const [body, setBody] = useState("");
  const [previewBody, setPreviewBody] = useState("");
  const [channelName, setChannelName] = useState("");
  const [type, setType] = useState(""); // 템플릿 타입
  const [windowType, setWindowType] = useState("variable");
  const [query, setQuery] = useState(window.location.search);
  const [defields, setDefields] = useState([]);
  const [contents, setContents] = useState([]);
  const [rows, setRows] = useState([]); // DE Contact 정보
  const [selected, setSelected] = useState([]); // 선택한 Contact 정보
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [header, setHeader] = useState("미리보기");
  const [ismms, setIsmms] = useState(null);
  // const [initData, setInitData] = useState(null); //journey Id로 저장된 데이터 로드
  const [validType, setValidType] = useState([]); //필드명에 따라 친구톡/알림톡 선택불가
  const [buttons, setButtons] = useState([]); //버튼 리스트
  const [quickReplies, setQuickReplies] = useState([]); //바로연결 리스트
  const [active, setActive] = useState(false); // 필드매핑모달
  const [active2, setActive2] = useState(false); // 미리보기 컨텍선택모달
  const [modalData, setModalData] = useState({
    idx: 0,
    value: "",
  });
  const [containerData, setContainerData] = useState({
    idx: null,
    type: "",
    value: "",
  });
  const [toast, setToast] = useState({
    active: false,
    status: "success",
    text: "",
  });
  const { setInitData } = useStore((state) => state.mapper);

  useEffect(() => {
    if (checkBlank([extensionId, journeyId, interactionId])) setTimeout(setIsSpinner(false), 1500);
  }, [extensionId, journeyId, interactionId]);

  const checkBlank = (datas) => {
    //console.log('datas : ',datas)
    return typeof datas === "object"
      ? datas?.reduce((a, c) => {
          //console.log(a,c,(c && c !== '' && a!==false))
          return c !== "" && c && a !== false;
        }, null) || false
      : datas && datas !== "";
  };

  function setTypeValidation() {
    let tmpVailidType = props.defields.reduce((a, c) => {
      let str = c.toLowerCase().replaceAll(" ", "");
      if (str.indexOf("faxnumber") > -1) a.push("AlimTalk");
      if (str.indexOf("auid") > -1) a.push("FriendTalk");
      return a;
    }, []);
    setType(!tmpVailidType.includes("FriendTalk") ? "AlimTalk" : "FriendTalk");
    setValidType(tmpVailidType);
  }

  function getInitMapping() {
    console.log("init");
    ApiRequest.post("/template/getMapping", { token: token, eventId: props.interactionId })
      .then((res) => {
        console.log("getMapping : ", res);
        if (res.data) {
          let items = res.data.items;
          if (items) setInitData(items[0].values);
        }
      })
      .catch((err) => {
        console.log("err : ", err);
      });
  }

  function getAccessToken() {
    //console.log('code : ',code)
    ApiRequest.post("/auth/getAccess", { code: code })
      .then((res) => {
        //console.log('getAccess : ',res)
        if (res.data) {
          console.log("token : ", res.data.access_token);
          setToken(res.data.access_token);
          setCode(res.data.refresh_token);
        }
      })
      .catch((err) => {
        console.log("err : ", err);
      });
  }

  function getAuthToken() {
    ApiRequest.get("/auth/getToken")
      .then((res) => {
        //console.log('getToken : ',res.data)
        props.onMove(res.data);
      })
      .catch((err) => {
        console.log("err : ", err);
      });
  }

  function getChannelInfo() {
    //console.log('token : ',token)
    ApiRequest.post("/channel/getChannels", { token: token })
      .then((res) => {
        //console.log('getChannels : ',res)
        if (res.data) {
          let items = res.data.items,
            tmpChannels = [];
          if (items) {
            for (const el of items) {
              tmpChannels.push(el.values);
            }
            setChannels(tmpChannels);
          }
        }
      })
      .catch((err) => {
        console.log("err : ", err);
      });
  }

  function getTemplates() {
    console.log("getTemplates : ", type);
    if (type === "" || !type) return;
    ApiRequest.post("/template/get" + type + "Templates")
      .then((res) => {
        let data = res.data,
          tmpTemplates = {};
        if (data) {
          //console.log("if문 안쪽 data", data)
          tmpTemplates = data.reduce((a, c) => {
            let channel = c.channel;
            a[channel] = a[channel] ? [...a[channel], c] : [{ code: "", name: "템플릿을 선택해주세요" }, c];
            return a;
          }, {});
        }
        console.log("getTemplate : ", type, tmpTemplates);
        ///console.log("set직전 template", tmpTemplates)
        setTemplates(tmpTemplates);
      })
      .catch((err) => {
        console.log("err : ", err);
      });
  }

  function getTokens() {
    //console.log('token : ',token)
    ApiRequest.post("/channel/getTokens", { token: token })
      .then((res) => {
        //console.log('getTokens : ',res)
        if (res.data) {
          let items = res.data.items,
            tmpTokens = [];
          if (items) {
            for (const el of items) {
              tmpTokens.push({ ...el.keys, ...el.values });
            }
            setTokens(tmpTokens);
          }
        }
      })
      .catch((err) => {
        console.log("err : ", err);
      });
  }

  function setPreview() {
    //console.log('token : ',token)
    ApiRequest.post("/channel/getRowData", { id: extensionId, token: token })
      .then((res) => {
        console.log("getRowData : ", res.data);
        if (res.data.items) {
          let items = res.data.items,
            tmpItems = items.reduce((a, c) => {
              let elements = c,
                tmpObj = Object.keys(elements).reduce((ia, ic) => {
                  let el = elements[ic];
                  for (let inner_key of Object.keys(el)) {
                    ia[inner_key] = el[inner_key];
                  }
                  return ia;
                }, {});
              a.push(tmpObj);
              return a;
            }, []);
          console.log("tmpItems : ", tmpItems);
          setRows(tmpItems);
          setActive2(true);
        }
      })
      .catch((err) => {
        console.log("err : ", err);
      });
  }

  function handleBody(body) {
    //console.log('body container : ',body)
    setPreviewBody(body);
    setBody(body);
  }

  function handleButtons(buttons) {
    //console.log('buttons : ',buttons)
    setButtons(buttons);
  }

  function handleQuickReplies(quickReplies) {
    //console.log('quickReplies : ',quickReplies)
    setQuickReplies(quickReplies);
  }

  function handleTemplte(template) {
    setTemplate(template);
  }

  function handelChannel(channel) {
    setChannel(channel);
    setChannelName(channel.name);
  }

  function handleType(type) {
    console.log("init type2 : ", type);
    setType(type);
  }

  function handleModal(data) {
    //console.log('handleModal',data)
    setModalData(data);
    setActive(true);
  }

  function handlContainer(data) {
    //console.log('handlContainer',data)
    setContainerData(data);
  }

  function handleContents(data) {
    setContents(data);
  }

  function handleChangeWindow(data) {
    let ret = data === "" ? (windowType === "variable" ? "preview" : "variable") : data;
    setWindowType(ret);
    if (ret === "preview") setPreview();
  }

  function handleSelectRows(data) {
    //console.log('selected : ',data)
    setCount(data.length);
    setPage(0);
    setSelected(data);
    setActive2(false);
    //setPreviewTexts()
  }

  function setPreviewTexts() {
    let tmp_body = body,
      selected_rows = rows.filter((row) => selected.includes(row["contact key"])),
      select = selected_rows[page];
    setHeader(select["contact key"]);
    //console.log(selected_rows)
    //console.log('setPreviewTexts : ',selected_rows, page, select)
    tmp_body = contents.reduce((a, c) => {
      if (c.type) a = a.replace(`#{${c.name}}`, c.type === "field" ? select[c.value.toLowerCase()] : c.type === "text" ? c.value : "");
      return a;
    }, tmp_body);
    setPreviewBody(tmp_body);
  }

  function handlePrev() {
    setPage(page - 1);
  }

  function handleNext() {
    //console.log('fire next')
    setPage(page + 1);
  }

  function handleIsMMS(value) {
    setIsmms(value);
  }

  function handleContents(value) {
    setContents(value);
  }

  function handleSave() {
    console.log('save : ',template)
    let status, text;
    ApiRequest.post("/template/setTemplate", {
      eventId: props.interactionId,
      token: token,
      values: {
        values: {
          template: body,
          channelKey: channel["key"],
          phoneNumber: channel["phonenumber"],
          code: template["code"],
          subject: template["subject"],
          type: type,
          ismms: ismms,
          mapping: JSON.stringify(contents),
          extendId: extensionId,
          buttons: JSON.stringify(buttons),
          quickreplies: JSON.stringify(quickReplies),
        },
      },
    })
      .then((res) => {
        //console.log('res : ',res)
        if (res.data) {
          if (res.request.status === 200) {
            status = "success";
            text = "저장되었습니다";
          } else {
            status = "error";
            text = "저장에 실패했습니다";
          }
        }
      })
      .catch((err) => {
        status = "error";
        text = "저장에 실패했습니다";
      })
      .finally(() => {
        showToast({
          active: true,
          status: status,
          text: text,
        });
      });
  }

  function showToast(obj) {
    setToast(obj);
    setTimeout(function () {
      setToast({
        active: false,
        status: "success",
        text: "",
      });
    }, 5000);
  }

  return (
    <Grid container spacing={1}>
      <Spinner />
      <Grid item xs={12}>
        <Header />
      </Grid>
      <Grid xs={8}>
        <Nav />
      </Grid>
      {/* <Grid xs={4}>
        <Mapper />
      </Grid> */}
      <Grid xs={4}>
        <Preview />
      </Grid>
    </Grid>
  );
}

export default Container;
